export default __webpack_public_path__ + "static/media/genai-ilp-preview.a5a3ac0a.png";